import React from 'react';

const Preguntas = () => {
    return (
        <div class="card text-center">
       <br/>
        <div class="card-body preguntasfrecuentes" >
          <h5 class="card-title">Preguntas Frecuentes</h5>
       
        </div>
      
      </div>
    );
}


export default Preguntas;